import * as Sentry from "@sentry/browser";
import { size } from "lodash-es";
import { createAsyncAction, errorResult, successResult } from "pullstate";
import { NETWORK_TO_PRICE_ENDPOINT_MAP } from "../../utils/bootstrapWagmi";
import { TokenMetadata, getTokens } from "../global/getTokenMetadata";
import { ActivityStore } from "./ActivityStore";

export const fetchAllTokens = (): Promise<TokenMetadata> => {
  return Promise.allSettled(
    Object.keys(NETWORK_TO_PRICE_ENDPOINT_MAP).map(networkName => getTokens(networkName, true))
  ).then(results => {
    const tokens: TokenMetadata = {};
    (
      results.filter(result => result.status === "fulfilled") as unknown as Array<
        PromiseFulfilledResult<TokenMetadata>
      >
    )
      .map(result => result.value)
      .forEach(result => {
        Object.assign(tokens, result);
      });
    return tokens;
  });
};

/* The point of retrieving the data from ALL /tokens endpoints is due to us having listed tokens on some networks and not others
 *  1. We need the tokens decimals in order to format values
 *  2. We also need the metadata for the token
 * */
export const getAllTokens = createAsyncAction(
  async (networkName: string) => {
    try {
      const result = await fetchAllTokens();

      if (result) {
        return successResult(result);
      }
    } catch (e) {
      console.log(e);
      Sentry.captureException(`Could not get tokens`, { extra: { event: e } });
      return errorResult([], `Could not get tokens for network ${networkName}`, e);
    }
    Sentry.captureException(`Could not get tokens`);
    return errorResult([], `Couldn't get tokens for network: ${networkName}`);
  },
  {
    postActionHook: ({ result }) => {
      if (!result.error) {
        ActivityStore.update(s => {
          if (size(result.payload) === 0) {
            console.log(`Got an empty response from the Tokens endpoint - dropping it`);
            Sentry.captureException(`tokens endpoint returned an empty response`);
            return null; // undefined for loading / not fetched yet, payload for fetched results and null for fetched but no results.
          }
          s.tokens = result.payload;
        });
      }
    },
  }
);
